import React from 'react';
import HeaderIconWithBadge from '@header/scripts/components/HeaderIconWithBadge.jsx';

export default function HeaderUser({user}) {
    const {linkTarget, loggedIn, texts} = user
    const accessibleText = loggedIn
        ? texts['cus__header_user_logged_in_accessibility']
        : texts['cus__header_user_not_logged_in_accessibility']

    return (
        <div className="header__user-wrapper">
            <a href={linkTarget} className="header__icon-box block">
                <HeaderIconWithBadge iconName="user" checked={loggedIn} accessibleText={accessibleText} />
            </a>
        </div>
    );
}
